"use client";

// Put all the global providers here

import { ToastProvider } from "@/components/ui/toastercustom";
import { DEFAULT_QUERY_SETTING } from "@/constants/variables";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
interface IProps {
  children: ReactNode;
}

const Providers = ({ children }: IProps) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        ...DEFAULT_QUERY_SETTING,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <ToastProvider>{children}</ToastProvider>
    </QueryClientProvider>
  );
};

export default Providers;
